import React, { useState, useEffect, useMemo } from 'react';
import cl from './Comments.module.css'

import tg from '../../Footer/img/1.png'
import yt from '../../Footer/img/2.png'
import plus from './img/1.png'
import minus from './img/2.png'
import ava from '../HeaderUser/img/avatar.png'
import { FOLDER_PROFILE } from '../../../API/API'
import useStore from '../../../store/usersStore'
import MyButton_1 from './../MyButton_1/MyButton_1';

import { jwtDecode } from 'jwt-decode';
import CommentsList from './CommentsList';
import CommentsService from '../../../API/CommentsService';
import Loader from '../Loader/Loader';
import { useLoader } from './../../../hooks/useLoader';

const Comments = () => {
    const { user_profile } = useStore();


    const [comments, setComments] = useState([]); // здесь храним комментарии
    const [judgement, setJudgement] = useState('0'); // здесь храним плюсы
    const [commentData, setCommentData] = useState(''); // Форма комментария нового
    const [errors, setErrors] = useState({}); // ошибки валидации
    const [changes, setChanges] = useState(''); // изменения, запускающие получение данных с сервера
    const [countSymbol, setcountSymbol] = useState(0); // количество символов комментария

    const [fetchData, isLoading, loadingError] = useLoader(async () => {

        const data_comments = await CommentsService.getUserCommentsMy();

        setComments(data_comments)
        const data_judgement = await CommentsService.getJudgementToUserIdMy();

        setJudgement(data_judgement)
    })

    useEffect(() => {
        fetchData()
    }, [changes])

    // нажать на плюс
    async function plus_reputacia() {
        const responce = await CommentsService.putJudgementProfile(jwtDecode(localStorage.getItem('Authorization')).id, '+')

        if (responce === 'Изменено') { setChanges(changes + 'true') }
        else if (responce === 'Уже изменено') { setErrors({ plus: 'Уже изменено' }) }
        else { setErrors({ plus: 'Ошибка' }) }

    }

    // нажать на минус
    async function minus_reputacia() {
        const responce = await CommentsService.putJudgementProfile(jwtDecode(localStorage.getItem('Authorization')).id, '-')

        if (responce === 'Изменено') { setChanges(changes + 'true') }
        else if (responce === 'Уже изменено') { setErrors({ plus: 'Уже изменено' }) }
        else { setErrors({ plus: 'Ошибка' }) }

    }

    // обработка изменений textarea
    const handleChange = (e) => {
        const { value } = e.target;
        setcountSymbol(value.length)
        setCommentData(value)
    };

    // Валидирует, проверяет на ошибки
    const validateForm = (data) => {
        const errors = {};
        if (!data.trim()) { errors.text = 'Комментарий не может быть пустым'; }
        if (data.length > 500) { errors.text = 'Максимальная длина коммента - 500 символов'; }
        return errors;
    };

    // Логика отправки формы здесь1
    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = validateForm(commentData);
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            const new_com = await CommentsService.postNewCommentProfileUser(jwtDecode(localStorage.getItem('Authorization')).id, commentData)
            if (new_com === 'Комментарий добавлен') {
                setCommentData('')
                setChanges(...changes + 'true')
            }
            else if (new_com === 'Слишком часто!') { setErrors({ text: 'Слишком часто!' }) }
            else if (new_com === 'Такой комментарий уже есть') { setErrors({ text: 'Такой комментарий уже есть' }) }
            else { setErrors({ text: 'Ошибка добавления комментария' }) }
        }
    }

    // Мемоизируем CommentsList чтобы он не перерендеривался при изменении commentData
    const memoizedCommentsList = useMemo(() => {
        return <CommentsList commentsList={comments} />;
    }, [comments]);

    return (
        <div className={cl.wrap_comments}>
            <div className={cl.wrap_comments_center}>
                <div className={cl.wrap_comments_center_header}>
                    <div>
                        <a
                            href="https://t.me/minecraftia_school"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                style={{ marginRight: 14, cursor: 'pointer' }}
                                src={tg}
                                alt="Telegram канал Майнкрафтии"
                            />
                        </a>
                        {/* <img src={yt} alt="" /> */}
                    </div>
                    <div className={cl.wrap_comments_center_header_counter}>
                        <img onClick={plus_reputacia} src={plus} alt="" />
                        <p>{judgement && judgement ? judgement : 0}</p>
                        <img onClick={minus_reputacia} src={minus} alt="" />
                    </div>
                </div>
                {errors.plus && (
                    <span className={cl.error_message_plus}>
                        {errors.plus}
                    </span>
                )}
                <div className={cl.wrap_comments_center_2}>
                    <p>Комментарии ({comments.length})</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={cl.wrap_comments_center_new_comment}>
                        <img src={user_profile && user_profile.photo ? FOLDER_PROFILE + user_profile.photo : ava} alt="" />
                        <div style={{ flexGrow: 1 }}>
                            <p>{user_profile && user_profile.firstName}
                                {countSymbol > 500
                                    ? <span style={{ marginLeft: 20, color: 'red' }} >{countSymbol}/500</span>
                                    : <span style={{ marginLeft: 20, color: 'black' }} >{countSymbol}/500</span>
                                }
                                {errors.text && (
                                    <span className={cl.error_message}>
                                        {errors.text}
                                    </span>
                                )}

                            </p>
                            <textarea placeholder='Комментарий' value={commentData} onChange={handleChange} name="comment"></textarea>
                        </div>
                    </div>
                    <div className={cl.btnRequestCam}>
                        <MyButton_1 type="submit" style={{ margin: '16px 0 0 0', float: 'right' }}>Отправить</MyButton_1>
                    </div>
                </form>
                <div className={cl.wrap_comments_center_comment}>
                    {isLoading
                        ? <Loader />
                        : memoizedCommentsList
                    }
                    {/* {loadingError &&
                        <p style={{textAlign:'center'}}>Ошибка загрузки</p>
                    } */}

                </div>
            </div>
        </div>
    )
};

export default Comments;